module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/56264bee3dfb230e7d95b2959c0a37f4.png";